import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input, OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { Chat, IMessengerConnector, Message, SendMessage } from '../../types/all.type';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject, finalize, ReplaySubject, Subject, takeUntil } from 'rxjs';
import { log } from '../../functions';
import { DcService } from '../../services/dc.service';
import { AllMessengersService } from '../../pages/page-start/all-messengers.service';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { AllService } from '../../services/all.service';
import { ModalService } from '../../services/modal.service';
import { TelegramService } from '../../pages/page-telegram/telegram.service';
import { NotifierWrapService } from '../../services/notifier-wrap.service';
import { LocalStorageService, SessionStorageService } from 'angular-web-storage';
import { InterfaceService } from '../../services/interface.service';
import { AppService } from '../../services/app.service';
import { debounceTime, filter } from 'rxjs/operators';
import { isMobile } from '../../functions';

@Component({
  selector: 'app-chat-show-inner',
  templateUrl: './chat-show-inner.component.html',
  styleUrls: ['./chat-show-inner.component.scss', '../chat-show/chat-show.component.scss']
})
export class ChatShowInnerComponent implements OnInit, OnDestroy {
  @Output() onNewChat = new EventEmitter<any>();
  @Output() onOpenProfile = new EventEmitter<any>();
  @Input() demoMessage: Message | false = false;
  showDetailInfoId: number | string;
  public isRecord = false;
  public isLoaded = false;
  @Input() id: any;
  @Input() Service: IMessengerConnector;
  FormMessage: UntypedFormGroup;
  uploadFile: any;
  isSending = false;
  _isFocusTextarea = false;
  _isHoverTextarea = false;
  public openChat: Chat;
  myDropzone: any;
  /*@ViewChild('fileSelect') fileSelect: ElementRef;
  @ViewChild('dropzoneTemplate') dropzoneTemplate: ElementRef;
  @ViewChild('dropzoneForm') dropzoneForm: DropzoneComponent;
  @ViewChild('dropzonePreviews') dropzonePreviews: ElementRef;
  @ViewChild('mediaTabs', {static: false}) mediaTabs: TabsetComponent;*/
  arFilesObj: any = [];
  arFiles: any = {};
  public messageLastDate: number;
  @ViewChild('scrollContainer') scrollContainer: ElementRef;
  @ViewChild('messageText') messageText: ElementRef;
  arSelectMessages: Message[] = [];
  @ViewChild('deleteModalContent', {read: TemplateRef})
  deleteModalContent: TemplateRef<any>;
  public resultSpellCheck: any = [];
  public spellCheckText: string;
  getSpellTimeout: NodeJS.Timeout;
  private destroy$: Subject<void> = new Subject();
  detectChanges$: ReplaySubject<string> = new ReplaySubject();
  arSearchMembers: any = [];
  selectUsername = '';
  selectUsernameIndex = 0;
  isMobile = isMobile();
  @HostListener('window:focus', ['$event'])
  onWindowFocus(event: FocusEvent) {
    this.cd.detectChanges();
  }

  constructor(
    private dcService: DcService,
    public allMessengersService: AllMessengersService,
    private snotifyService: SnotifyService,
    public allService: AllService,
    private cd: ChangeDetectorRef,
    public modalService: ModalService,
    public telegramService: TelegramService,
    public notifierWrapService: NotifierWrapService,
    public local: LocalStorageService,
    public session: SessionStorageService,
    public interfaceService: InterfaceService,
    public appService: AppService
  ) {
    this.dcService.detectChangesConnect$.subscribe(() => {
      this.detectChanges$.next('detectChangesConnect$');
    });
  }

  addMessage(result) {
    if (result.id) {
      result.show = true;
      this.Service.arHistory.push(result);
      this.interfaceService.scrollChat$.next();
    }
  }

  enterMessage(event) {
    event.preventDefault();
    this.Service.message = this.Service.message.replace(/\n+$/m, '');
    if (this.Service.editMessage) {
      this.saveMessage();
    } else {
      this.sendMessage(event);
    }
  }

  ngOnInit(): void {
    this.initForm();

    this.cancelReply();
    this.cancelForward();
    this.interfaceService._showMobileHome = false;
    this.detectChanges('openChat$');
    this.init();
    this.focusDesktopTextarea();
    // this.initDropdown();
    this.dcService.detectChanges$.pipe(
      filter(v => v === 'chat-show'), debounceTime(100), takeUntil(this.destroy$)
    ).subscribe((component) => {
      this.detectChanges$.next('dcService.detectChanges$');
    });
    this.interfaceService.focusTextArea$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val) {
        this.focusTextArea();
      }
    });

    this.interfaceService.positionTextArea$.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (this.interfaceService.messageTextareaType !== 'editor' && val) {
        setTimeout(() => {
          this.messageText.nativeElement.setSelectionRange(val + 1, val + 1);
          this.setTextAreaPosition();
        }, 50);
      }
    });
    this.detectChanges$.pipe(debounceTime(500)).subscribe((text) => {
      this.detectChanges('$ ' + text);
    });
  }

  detectChanges(text: string): void {
    if (this.interfaceService.isFocused()) {
      log('ChatShowComponent detectChanges', text);
      this.cd.detectChanges();
    }
  }

  init() {
    this.switchDraftMessage(this.Service.openChatId);
    this.onCloseVoice();
    this.cancelSpellCheck();
    this.cancelSearchMembers();
    this.Service.editMessage = false;
    if (this.Service.openChatId) {
      setTimeout(() => {
        this.arSelectMessages = [];

        this.showDetailInfoId = this.Service.openChatId;
        // this.showDetailInfo = false;
        // this.initDropdown();
      }, 300);
    } else {
      this.Service.arHistory = [];
      // delete this.myDropzone;
    }
    this.detectChanges$.next('init');
  }

  focusTextArea() {
    if (this.allService.permissionsCheck('can_send_messages', this.Service)) {
      try {
        this.messageText.nativeElement.focus();
      } catch (e) {
      }
    }
  }

  saveDraftMessage() {
    if (!this.Service.editMessage) {
      this.allService.savedDraft[this.Service.openChatId] = {
        message: this.Service.message
      };
      this.allService.saveDraft();
    }
  }

  switchDraftMessage(id) {
    // Save draft
    if (this.allService.lastChatId) {
      if (this.myDropzone) {
        this.myDropzone.removeAllFiles();
      }
      this.allService.savedDraft[this.allService.lastChatId] = {
        message: this.Service.message,
        files: this.arFilesObj
      };
      this.arFilesObj = [];
      if (this.Service.replyMessage) {
        this.allService.saveReplyDraft(this.allService.lastChatId, this.Service.replyMessage);
      }
    }
    // Restore draft
    this.Service.replyMessage = this.allService.restoreReplyDraft(id);
    if (this.allService.savedDraft[id]) {
      this.Service.message = this.allService.savedDraft[id].message;
    } else {
      this.interfaceService.clearTextArea$.next();
    }
    this.allService.saveDraft();
  }

  cancelSpellCheck(): boolean {
    if (this.resultSpellCheck?.length > 0) {
      this.resultSpellCheck = [];
      this.spellCheckText = '';
      this.detectChanges('cancelSpellCheck');
      return true;
    }
  }

  spellCheck(timeout = 800) {
    if (!this.spellCheckText) {
      timeout = 100;
    }
    clearTimeout(this.getSpellTimeout);
    this.getSpellTimeout = setTimeout(() => {
      if (!this.Service.message || this.Service.message?.length < 3 || this.allService.isTouchDevice) {
        this.cancelSpellCheck();
        return;
      }
      this.allService.getSpellCheck(this.Service.message?.replace(/(<([^>]+)>)/gi, '')).subscribe((res) => {
        this.resultSpellCheck = res;
        this.spellCheckText = this.Service.message?.toString();
        res.forEach((v) => {
          if (v.s?.length > 0 && v.s[0]?.length > 0) {
            this.spellCheckText = this.spellCheckText.replace(v.word, `<i>${v.s[0]}</i>`);
          }
        });
        this.detectChanges('getSpellCheck');
      });
    }, timeout);
  }

  clickSpellItem($event): void {
    if ($event?.path?.length > 0) {
      const spellItem = $event?.path[0];
      if (spellItem?.localName === 'i') {
        const findSpell = this.resultSpellCheck.find((v) => v.s[0] === spellItem.innerHTML);
        if (findSpell) {
          const firstSpace = findSpell.pos !== 0 ? ' ' : '';
          const lastSpace = findSpell.pos + findSpell.len !== this.Service.message?.length ? ' ' : '';
          // @ts-ignore
          this.Service.message = this.Service.message.replaceAll(
            firstSpace + findSpell.word + lastSpace,
            firstSpace + spellItem.innerHTML + lastSpace
          );
          this.spellCheck(0);
        }
      }
    }
  }

  replaceAllSpell(): void {
    let newString = this.Service.message;
    this.resultSpellCheck.forEach((findSpell) => {
      const firstSpace = findSpell.pos !== 0 ? ' ' : '';
      const lastSpace = findSpell.pos + findSpell.len !== this.Service.message?.length ? ' ' : '';
      // @ts-ignore
      newString = newString?.replaceAll(
        firstSpace + findSpell.word + lastSpace,
        firstSpace + findSpell.s[0] + lastSpace
      );
    });
    this.Service.message = newString;
    this.cancelSpellCheck();
  }

  focusDesktopTextarea(): void {
    if (!this.isMobile) {
      setTimeout(() => {
        this.focusTextArea();
      }, 150);
      this.spellCheck();
    }
  }

  textareaMouseenter(): void {
    if (this.isPreviewTextarea) {
      this._isHoverTextarea = true;
      if (!this.interfaceService._supportsEmoji) {
        this.detectChanges$.next('textareaMouseenter');
      }
    }
  }

  textareaMouseout(): void {
    this._isHoverTextarea = false;
    if (!this.interfaceService._supportsEmoji) {
      this.detectChanges$.next('textareaMouseout');
    }
  }

  textareaInput($event): void {
    if (!this.Service.message) {
      return;
    }
    // this.onPasteLinkMedia($event);
    this.selectUsernameIndex = 0;
    this.saveDraftMessage();
    this.setTextAreaPosition();
    if (!this.allService.isTouchDevice) {
      this.spellCheck();
    }
    // log('!!!!!!!!!!!!!!!', this.Service.message);
    let lastWord: any = this.Service.message?.split(' ');
    lastWord = lastWord[lastWord?.length - 1];
    if (lastWord && lastWord.includes('@')) {
      this.selectUsername = lastWord.match(/@([^ ]*)/)[1]?.toLowerCase();
      if (this.selectUsername) {
        this.arSearchMembers = this.Service.openChat.members?.filter(
          (v) =>
            v?.username?.includes(this.selectUsername) ||
            v?.name?.first?.toLowerCase()?.includes(this.selectUsername) ||
            v?.name?.last?.toLowerCase()?.includes(this.selectUsername) ||
            v?.phone_number?.includes(this.selectUsername)
        ) || [];
      } else {
        this.arSearchMembers = this.Service.openChat.members;
      }
      if (this.arSearchMembers?.length > 0) {
        this.arSearchMembers = this.arSearchMembers.filter((v) => v?.username !== this.Service.arProfile?.username);
      }
      this.detectChanges('textareaInput');
    } else {
      this.cancelSearchMembers();
    }
  }

  selectMember(member: any): void {
    if (this.selectUsername) {
      log('Replace', this.selectUsername, member);
      this.Service.message = this.Service.message.replace(this.selectUsername, (member?.username || member?.name?.first) + ' ');
    } else {
      log('Add end', member);
      // TODO fix name
      this.Service.message += (member?.username || member?.name?.first) + ' ';
    }
    this.interfaceService.focusTextArea$.next(true);
    this.cancelSearchMembers();
  }

  cancelSearchMembers(): boolean {
    if (this.arSearchMembers?.length > 0) {
      this.arSearchMembers = [];
      this.detectChanges('cancelSearchMembers');
      return true;
    }
  }

  textareaFocus(): void {
    if (this.isMobile) {
      this.interfaceService.showTabsInput$.next(false);
      this.isFocusTextarea = true;
    }
    this.detectChanges$.next('textareaFocus');
  }

  textareaEnter(e): void {
    if (this.arSearchMembers?.length > 0) {
      this.selectMember(this.arSearchMembers[this.selectUsernameIndex]);
    } else {
      this.enterMessage(e);
    }
    e.preventDefault();
  }

  textareaKeyUp(e: any): void {
    this.setTextAreaPosition();
    if (e.code === 'ArrowDown') {
      if (this.selectUsernameIndex < this.arSearchMembers?.length - 1) {
        this.selectUsernameIndex++;
      }
    }
    if (e.code === 'ArrowUp') {
      if (this.selectUsernameIndex > 0) {
        this.selectUsernameIndex--;
      }
    }
  }

  textareaFocusout(): void {
    // this.senderAddForm = false;
    this.isFocusTextarea = false;
  }
  textareaPasted(e) {

  }
  get isPreviewTextarea() {
    return (
      !this.interfaceService._supportsEmoji &&
      !this.isMobile &&
      !this._isFocusTextarea &&
      !this._isHoverTextarea &&
      this.Service.message
    );
  }

  set isFocusTextarea(val) {
    this._isFocusTextarea = val;
    if (!this.interfaceService._supportsEmoji) {
      this.detectChanges$.next('isFocusTextarea');
    }
  }

  initForm() {
    this.FormMessage = new UntypedFormGroup({
      text: new UntypedFormControl(null, [Validators.required, Validators.minLength(1)])
    });
  }


  editCancel(): boolean {
    if (this.Service.editMessage) {
      this.Service.message = this.Service.bufferMessage;
      delete this.Service.bufferMessage;
      this.Service.editMessage = false;
      this.detectChanges('editCancel');
      this.interfaceService.$onCancelEdtMessage.next();
      return true;
    }
  }

  saveMessageDisabled() {
    if (this.Service.editMessage) {
      if (this.Service.type === 'sender') {
        return !this.Service.senderForm.dirty && this.Service.message === this.Service.editMessage.text;
      } else {
        return this.Service.message?.length === 0 || this.Service.message === this.Service.editMessage.text;
      }
    }
    return true;
  }

  saveMessage() {
    if (!this.Service.editMessage) {
      return;
    }
    this.Service.message = this.Service.message.split('\n').join('<br />');
    const arMessage: any = this.Service.editMessage;
    arMessage.chat_id = this.Service.openChatId;
    arMessage.text = this.Service.message?.replace(/<p>/gi, '')?.replace(/<\/p>/gi, '<br>');
    this.Service.saveMessage(arMessage, this.arFiles).subscribe(
      (result: any) => {
        if (this.Service.editMessage) {
          this.Service.editMessage.edit_date = new Date().getTime() / 1000;
          if (arMessage.sender) {
            this.Service.editMessage.sender = result.sender;
          }
          this.Service.editMessage.text = arMessage.text;
        }
        this.Service.message = this.Service.bufferMessage;
        this.Service.editMessage = false;
        this.dcService.detectChanges$.next('message-' + arMessage.id);
        this.detectChanges('saveMessage');
      },
      (error) => {
        this.interfaceService.errorHandling(error);
      }
    );
  }

  sendMessage(event: any = false) {
    if (event) {
      event.preventDefault();
    }
    this.focusTextArea();
    const controls = this.FormMessage.controls;
    console.log('Send message start', this.Service.message);
    // Проверяем форму на валидность */
    if (!this.Service.message && this.arFilesCount === 0 && !this.Service.disabledMessageTextarea) {
      // Если форма не валидна, помечаем все контролы как touched **/
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());

      this.notifierWrapService.notify('error', 'Введите ' +
        (this.Service.type === 'sender' ? 'текст рассылки' : 'текст сообщения'));
      log('FormMessage.invalid', this.FormMessage, this.arFilesCount, this.Service.disabledMessageTextarea, this.Service.message);
      this.isSending = false;
      return;
    }
    this.isSending = true;
    const arMessage: SendMessage = {
      chat_id: this.Service.openChatId,
      chat_type: this.Service.openChat.type,
      text: this.Service.message?.replace(/<p>/gi, '')?.replace(/<\/p>/gi, '<br>'),
      attachments: Object.keys(this.arFiles)
    };
    if (this.Service.replyMessage) {
      arMessage.reply_message = this.Service.replyMessage;
    }
    if (this.Service.forwardMessage) {
      arMessage.forward_message = this.Service.forwardMessage;
    }
    this.detectChanges$.next('sendMessage');
    console.log('Send message', this.arFiles, arMessage);
    this.Service.sendMessage(arMessage).subscribe(
      (result: any) => {
        this.cancelReply();
        this.cancelForward();
        this.cancelSpellCheck();
        this.cancelSearchMembers();
        if (this.myDropzone) {
          this.myDropzone.removeAllFiles();
        }
        this.arFiles = {};
        if (this.isMobile) {
          this.interfaceService.showTabsInput$.next(false);
        }
        result.forEach((message: Message) => {
          message.show = true;
          message.service_class = this.Service.type;
          this.allService.newMessage$.next(message);
        });
        this.interfaceService.clearTextArea$.next();
        this.allService.clearDraft(this.Service.openChatId);
        setTimeout(() => {
          this.interfaceService.scrollChat$.next();
        }, 100);
        this.interfaceService.$onCancelAddSender.next();

        this.isSending = false;
        this.detectChanges$.next('POST sendMessage');
      },
      (error) => {
        log('Error sendMessage', error);
        this.isSending = false;
        this.cd.detectChanges();
        this.interfaceService.errorHandling(error);
      }
    );
  }

  cancelReply(): boolean {
    if (this.Service.replyMessage) {
      this.Service.replyMessage = false;
      this.allService.clearReplyDraft(this.Service.openChatId);
      return true;
    }
  }

  cancelForward(): boolean {
    if (this.Service.forwardMessage) {
      this.Service.forwardMessage = false;
      return true;
    }
  }

  startRecord() {
    if (this.isMobile) {
      this.interfaceService.showTabsInput$.next(false);
    }
    this.isRecord = true;
    this.detectChanges('startRecord');
  }

  onCloseVoice() {
    if (this.isRecord) {
      this.isRecord = false;
      this.detectChanges('onCloseVoice');
    }
  }
  get arFilesCount(): number {
    return Object.keys(this.arFiles)?.length;
  }

  scrollToMessage(message: Message) {
    this.interfaceService.scrollToMessage$.next(message);
  }

  toggleMessage(message: Message) {
    if (this.arSelectMessages?.length > 0 || message.force_select) {
      message.select = !message.select;
      if (message.select) {
        this.arSelectMessages.push(message);
      } else {
        const findIndex = this.arSelectMessages.findIndex((v) => v.id === message.id);
        this.arSelectMessages.splice(findIndex, 1);
      }
      this.detectChanges$.next('toggleMessage');
    }
  }

  deleteSelectMessages() {
    const deleteMessage = (isDeleteAllMessage = false) => {
      this.Service.deleteMessages(this.Service.openChatId, isDeleteAllMessage, this.arSelectMessages.map((v) => v.id)).subscribe(
        (result: any) => {

          this.Service.arHistory
            .filter((v) => v.select)
            .map((v) => {
              v.delete = true;
              v.select = false;
              this.dcService.detectChanges$.next('message-' + v.id);
            });
          this.allService.wsService.wsMessages$.next({
            event: 'delete_messages',
            type: this.Service.type,
            data: {delete_messages: this.arSelectMessages.map((v) => v.id)}
          });
          this.arSelectMessages = [];
          this.detectChanges$.next('deleteSelectMessages');
          this.notifierWrapService.notify('success', 'Сообщения удалены', SnotifyPosition.centerTop);
        },
        (error) => {
          this.interfaceService.errorHandling(error);
        }
      );
    };
    this.snotifyService.clear();
    this.snotifyService.confirm('Вы действительно хотите удалить сообщения?', '', {
      timeout: 30000,
      showProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      position: SnotifyPosition.centerTop,
      buttons: [
        {
          text: 'Да',
          action: () => {
            deleteMessage();
          },
          bold: false
        },
        {
          text: 'Для всех',
          action: () => {
            deleteMessage(true);
          },
          bold: true
        },
        {text: 'Отменить', action: () => log('Clicked: No')}
      ]
    });
    this.notifierWrapService.playAudio('alert');
  }

  editMessageText(message: Message) {
    this.cancelReply();
    this.cancelForward();
    this.allService.clearReplyDraft(this.Service.openChat?.id);
    this.Service.bufferMessage = this.Service.message;
    this.Service.message = message.text.split('<br />').join('\n');
    this.Service.editMessage = message;
    this.interfaceService.$onEdtMessage.next(this.Service.type);
    this.focusTextArea();
    this.detectChanges$.next('editMessageText');
  }

  replyMessageText(message: Message) {
    if (this.arSelectMessages?.length === 0 && this.Service.type !== 'sender') {
      this.interfaceService.focusTextArea$.next(true);
      this.Service.editMessage = false;
      this.Service.replyMessage = message;
      this.allService.saveReplyDraft(this.Service.openChatId, message);
      this.detectChanges$.next('replyMessageText');
    }
  }

  setTextAreaPosition() {
    if (this.interfaceService.messageTextareaType !== 'editor') {
      const element = this.messageText.nativeElement;
      element.focus();
      if (element.selectionStart) {
        this.allService.textAreaPosition = element.selectionStart;
        return;
      }
      this.allService.textAreaPosition = false;
    }

  }

  get arTyping(): any {
    return this.Service.arTyping.filter((v) => v.user_id === this.Service.openChatId);
  }

  get runChangeDetection() {
    this.allService.arDetectChangesLog.ChatShowComponent++;
    return '';
  }

  get countAccounts(): number {
    return this.allMessengersService.getServicesFilter('isAuth', true)?.length;
  }

  ngOnDestroy() {
    console.error('Destroy carusel');
    this.destroy$.next();
    this.destroy$.complete();
    /*this.myDropzone?.destroy();
    delete this.myDropzone;*/
  }

  messageInputClick(): void {
    if (this.interfaceService.isMessageInputAnimate) {
      this.interfaceService.isMessageInputAnimate = false;
      localStorage.setItem('message-animate', 'Y');
      this.cd.detectChanges();
    }
  }

  openDetailInfo(message: Message) {
    this.modalService.openModal('ModalChatDetailComponent', {
      Service: this.Service,
      id: message.from_user.username || message.from_user.id,
      type: 'user'
    });
  }

}
